export const NY_PATH = "/novyy-god-2027";
export const NY_POSTER = "/api/storage/public-objects/campaigns/new-year-2027.webp";
export const NY_PHONE_HREF = "tel:+78129911090";
export const NY_PHONE = "+7 (812) 991-10-90";
export const NY_START_ISO = "2026-12-31T22:00:00+03:00";
// Campaign promotion ends at 2027-01-01 00:00 Moscow time
const NY_PROMO_END = Date.parse("2027-01-01T00:00:00+03:00");

export function isCampaignActive(now = Date.now()) {
  return now < NY_PROMO_END;
}

/** Identify the New Year event in afisha by title/date, not ID. */
export function isNewYearEvent(e: { title: string; date: string }) {
  const t = e.title.toLowerCase();
  return (t.includes("новый год") || t.includes("новогод")) && e.date.startsWith("2026-12-31");
}

export const NY_PROGRAM = [
  { t: "Дресс-код «Императорский бал»", d: "Вечерние платья, костюмы, блеск и корона по желанию" },
  { t: "Торжественная встреча", d: "Встреча гостей и бокал игристого" },
  { t: "Душевное застолье", d: "Конкурсы и розыгрыши" },
  { t: "Дед Мороз и Снегурочка", d: "Для маленьких гостей — праздник вместе с Дедом Морозом" },
  { t: "Караоке", d: "Для самых смелых голосов" },
  { t: "Лучшие диджеи города", d: "Танцевальные хиты 2026 от арт-группы ресторана Паруса" },
  { t: "Финал", d: "Танцевальная дискотека под новогодние хиты арт-группы Паруса — настроение до самого утра" },
];

export const NY_MENU = [
  { course: "Холодная закуска", dish: "Крудо из морского гребешка с мандарином, юдзу и красной икрой" },
  { course: "Салат", dish: "Креветка с авокадо" },
  { course: "Горячая закуска", dish: "Крокеты из утки конфи с бататом и пряной вишней" },
  { course: "Горячее", dish: "Говядина Веллингтон с трюфельным демигласом" },
  { course: "Десерт", dish: "Новогодняя шишка" },
];
